// Branch helpers shared by the global branch context and the page-local branch select.

export const branchDataFactory = (data = {}) => ({
  disabled: undefined,
  custom_id: data?.branch_number,
  mms_unit_unzer_id: data?.mms_unit_unzer_id,
  mms_type: data?.mms_type,
  label: data.name || data.branch_number,
  id: data.id
})

/**
 * Disables the branches the user is not assigned to and sorts them last.
 * `userAssignedLocations === null` means the user has access to every branch.
 */
export function withAccess(branchesData, userAssignedLocations) {
  return branchesData
    .map((item) => ({
      ...item,
      disabled:
        Array.isArray(userAssignedLocations) &&
        !userAssignedLocations.includes(item.id)
    }))
    .sort((a, b) => a.disabled - b.disabled)
}

/**
 * Returns the id of the branch to preselect for the user, or undefined when
 * the user has to choose one.
 */
export function getAutoBranchId({
  isPrivileged,
  hasSelection,
  branchesData,
  locationList,
  userAssignedLocations
}) {
  const userIsEverywhere = userAssignedLocations === null
  const userIsNowhere =
    Array.isArray(userAssignedLocations) && !userAssignedLocations.length

  if (
    isPrivileged ||
    hasSelection ||
    (branchesData.length > 1 && userIsEverywhere)
  ) {
    return
  }

  if (
    Array.isArray(userAssignedLocations) &&
    userAssignedLocations.length === 1
  ) {
    return userAssignedLocations[0]
  }
  if (branchesData.length === 1 && !userIsNowhere) {
    return branchesData[0].id
  }
  if (
    branchesData.length > 1 &&
    Array.isArray(userAssignedLocations) &&
    userAssignedLocations.length > 1
  ) {
    return locationList[0].id
  }
}
